{
    "name": "k",
    "actionTrace": [
        {
            "type": "invoke skill",
            "skillKey": "smite",
            "performerKey": "hero",
            "position": {
                "x": 14,
                "y": 15,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 15,
                "z": 1
            }
        }
    ],
    "deltastageSum": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit"
                ],
                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "portraits": {
                    "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                    "angry": "./RP-angry-AJ6PJQEY.png",
                    "happy": "./RP-happy-HEYINXAH.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 15,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 14,
                        "y": 15,
                        "z": 1
                    },
                    "key": "gEJIW",
                    "tag": "spawn"
                }
            },
            "hero": {
                "key": "hero",
                "jobKey": "hammer",
                "aliases": [
                    "Himmel",
                    "paladin",
                    "Masked Man"
                ],
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit"
                ],
                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 15,
                    "z": 1
                },
                "spawnspot": {
                    "position": {
                        "x": 16,
                        "y": 15,
                        "z": 1
                    },
                    "key": "7sJFA",
                    "tag": "spawn"
                },
                "experience": 10,
                "energy": {
                    "key": "hero",
                    "energy": {
                        "move": false,
                        "invoke skill": false
                    }
                }
            }
        },
        "dialogue": {},
        "audio": {
            "triggerKey": "Unit:Attack"
        },
        "intent": {
            "type": "reposition",
            "positions": [
                {
                    "x": 14,
                    "y": 15,
                    "z": 1
                },
                {
                    "x": 13,
                    "y": 15,
                    "z": 1
                },
                {
                    "x": 12,
                    "y": 15,
                    "z": 1
                }
            ]
        }
    },
    "sequenceLengthRemaining": 0,
    "chapterSlug": "demo",
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0
        },
        "party": {
            "units": {
                "princess": {
                    "key": "princess",
                    "jobKey": "sword",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "moverange": 2,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit"
                    ],
                    "name": "PRINCESS",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    },
                    "portraits": {
                        "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                        "angry": "./RP-angry-AJ6PJQEY.png",
                        "happy": "./RP-happy-HEYINXAH.png"
                    }
                },
                "hero": {
                    "key": "hero",
                    "jobKey": "hammer",
                    "aliases": [
                        "Himmel",
                        "paladin",
                        "Masked Man"
                    ],
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit"
                    ],
                    "name": "HERO",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "friend": {
                    "key": "friend",
                    "jobKey": "bow",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit"
                    ],
                    "name": "FRIEND",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "aide": {
                    "key": "aide",
                    "jobKey": "dagger",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit"
                    ],
                    "name": "AIDE",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                }
            }
        }
    },
    "gameSlug": "war",
    "randomSeed": "dPeNFgBESSdQrYcgWx7ok",
    "captureDate": 1738091591778,
    "data": {}
}